export default {
  methods: {
    ibanFormatter (value) {
      if (value === null) {
        return ''
      }

      let iban = value.toUpperCase().replace(/[^\dA-Z]/g, '')
      if (iban.length > 2 && iban.substring(0, 2) === 'DE') {
        iban = 'DE' + iban.replace(/[^\d]/g, '')
        if (iban.length > 22) {
          iban = iban.substring(0, 22) // maxlength for german IBANs
        }
      } else if (iban.length < 3) {
        iban = iban.replace(/[\d]/g, '') // First two chars have to be letters
      } else if (iban.length === 3 && isNaN(iban.substring(2, 3))) {
        iban = iban.substring(0, 2) // 3rd char has to be a number
      } else if (iban.length < 5 && isNaN(iban.substring(3, 4))) {
        iban = iban.substring(0, 3) // 4rd char has to be a number
      } else if (iban.length > 34) {
        iban = iban.substring(0, 34) // maxlength
      }
      return iban.replace(/(.{4})/g, '$1 ').trim()
    }
  }
}
